import type { TipsContent } from "@/app/components/Tips";

const contactInformation: { contact: { name: TipsContent }; email: TipsContent; address: TipsContent } = {
	contact: {
		name: {
			label: "Name",
			summary:
				"Name and contact information will be the first thing a recruiter sees on your resume, so it's important to organize this information in a clean manner to make a positive first impression.",
			tips: [
				"Should match the name on your LinkedIn profile",
				"Generally best to use your full birth name as opposed to nicknames",
				"It's your choice whether or not to include your middle name or middle initial",
			],
		},
	},
	email: {
		label: "Email Address",
		summary: "76% of resumes are discarded for having unprofessional email address.",
		tips: [
			"Keep it professional, make sure it's from a modern provider such as Gmail",
			"Make sure not to tie it to the email address of your current employer",
			"So keep born2Bw1ld@ or QTpie89 between friends only",
		],
	},
	address: {
		label: "Address",
		tips: [
			{
				text: "Standard to include the address you'll be spending majority of your time during the interview process.",
				items: ["City/Town", "Region (State)", "Country"],
			},
			"Don't put more than one address on the resume",
		],
	},
};

export default contactInformation;
